import { FC, useState, createContext, useContext } from 'react';
type ForwardContext = {
  selectedMessages: number[];
  toggleMessageSelection: (messageId: number) => void;
  handleCancel: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForwardContext = createContext<ForwardContext>(
  {} as ForwardContext
);

export const ForwardProvider: FC = ({ children }) => {
  const [selectedMessages, setSelectedMessages] = useState<number[]>([]);

  const toggleMessageSelection = (messageId: number) => {
    setSelectedMessages((prevSelected) =>
      prevSelected.includes(messageId)
        ? prevSelected.filter((id) => id !== messageId)
        : [...prevSelected, messageId]
    );
  };

  const handleCancel = () => {
    setSelectedMessages([]);
  };

  return (
    <ForwardContext.Provider
      value={{ selectedMessages, toggleMessageSelection, handleCancel }}
    >
      {children}
    </ForwardContext.Provider>
  );
};

export const useForward = () => {
  return useContext(ForwardContext);
};
